const initialState = () => ({
  items: [],
  max: 10,
});

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    push(state, {
      title,
      message,
      position = 'bottom-right',
      type,
    }) {
      state.items.push({
        title, message, position, type,
      });

      if (state.items.length > state.max) {
        state.items.shift();
      }
    },
    addNotifySuccess(state, errors) {
      state.items = errors.map((message) => ({
        title: 'Успешно!',
        message,
        position: 'bottom-right',
        type: 'success',
      }));
    },
    addNotifyErrors(state, errors) {
      if (errors) {
        state.items = errors.map((message) => ({
          title: 'Ошибка',
          message,
          position: 'bottom-right',
          type: 'error',
        }));
      } else {
        state.items.push({
          title: 'Ошибка',
          position: 'bottom-right',
          type: 'error',
        });
      }
    },
    clear(state) {
      state.items = [];
    },
  },
  getters: {
    items: (state) => state.items,
  },
};
